import React from 'react';
import {Formik, Field, Form} from 'formik';
import {observable} from 'mobx';
import {inject, observer} from 'mobx-react';
import {withRouter, Link, Switch, Route} from "react-router-dom";
import {matchPath} from 'react-router';
import classnames from 'classnames';


@inject("store")
@observer
class SignIn extends React.Component {
    @observable showForgotPassword = false;
    @observable resetSubmitted = false;
    @observable resetButtonText = "Request password reset";
    @observable resetButtonSubmitted = false;

    constructor(props) {
        super(props);
        this.toggleShowForgotPassword = this.toggleShowForgotPassword.bind(this);
        this.validateSignIn = this.validateSignIn.bind(this);
        this.validateStartResetPassword = this.validateStartResetPassword.bind(this);
        this.state = {};
    }


    validateSignIn = values => {
        const navigation = this.props.store.navigation;
        const dictionary = navigation.dictionary;

        
        let errors = {};
        // if (values.email === undefined || values.email.length ===0) {
        //     errors.email = dictionary["Login.EmailRequired"];
        // } else if (!(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email))) {
        //     errors.email = dictionary["Login.EmailInvalid"];
        // }
        //
        // if (values.password.length === 0) {
        //     errors.password = dictionary["Login.PasswordRequired"];
        // }

        //console.log("validateSignIn", errors);
        
        return errors;
    };


    validateStartResetPassword = values => {
        const navigation = this.props.store.navigation;
        const dictionary = navigation.dictionary;

        let errors = {};
        if (!values.email) {
            errors.email = dictionary["Login.EmailRequired"];
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
            errors.email = dictionary["Login.EmailInvalid"];
        }

        return errors;
    };


    toggleShowForgotPassword() {
        this.showForgotPassword = !this.showForgotPassword;
    }

    render() {

        const navigation = this.props.store.navigation;
        const dictionary = navigation.dictionary;
        const account = this.props.store.account;

        const match = this.props.match;
        let matchUrl = match.url;
        if (matchUrl.length === 1 && matchUrl[0] === "/") {
            matchUrl = "";
        }
        //console.debug("Match Url Reset password: ", `${matchUrl}/resetpassword`);
        return (
            <div>
                <Switch>
                    <Route path={`${matchUrl}/resetpassword`}>
                        <Formik
                            key={"reset-password-form"}
                            state={this.state}
                            initialValues={{
                                email: '',
                                password: ''
                            }}
                            validate={this.validateStartResetPassword}
                            onSubmit={(values, actions, resetForm) => {
                                actions.setStatus({submitting: true, sent: false});
                                this.resetButtonSubmitted = true;
                                this.props.store.account.startPasswordReset(values).then(
                                    status => {
                                        console.debug(status);
                                        actions.setSubmitting(false);
                                        actions.setStatus({submitting: false, sent: true});
                                        setTimeout(() => {
                                            actions.resetForm();
                                        }, 5000);
                                    },
                                    error => {
                                        console.debug(error);
                                        actions.setFieldError("custom", error.messages[0]);
                                        actions.setSubmitting(false);

                                        actions.setStatus({submitting: false, sent: false});
                                    }
                                );
                            }}
                        >
                            {({errors, touched, isSubmitting, isValid, status}) => {
                                return (
                                    <Form id="reset-form">
                                        <h2>{dictionary["ForgotPassword.Title"]}</h2>
                                        <ol>
                                            {(dictionary["ForgotPassword.Instructions"] || "").split(";").map((x, i) => {
                                                return <li key={i}>{x}</li>
                                            })}
                                        </ol>
                                        <div className={classnames("form-group", "input-group", {'has-warning': errors.email && touched.email})}>
                                            <Field className="form-control" name="email" type="email" placeholder={dictionary["Login.EmailPlaceholder"]} autoFocus/><span className="input-group-addon"><i
                                            className="material-icons mail"></i></span>
                                            {errors.email &&
                                                touched.email &&
                                                <div className="form-control-feedback">{errors.email}</div>}
                                        </div>

                                        <button className="btn btn-success btn-block" type="submit" disabled={!isValid || (status && (status.sent || status.submitting))}>
                                            {status && status.sent ? <span>{dictionary["ForgotPassword.Button.Sent"]}<i key="icon" className="material-icons check"></i></span> : null}
                                            {status && status.submitting ? <span>{dictionary["ForgotPassword.Button.Waiting"]}</span> : null}
                                            {!status || (!status.sent && !status.submitting) ? <span>{dictionary["ForgotPassword.Button"]}</span> : null}
                                        </button>

                                        {errors.custom && <div>{errors.custom}</div>}
                                        <br/>
                                        <Link to={`${matchUrl}/login`} className={""}>{dictionary["ForgotPassword.Back"]}</Link>

                                    </Form>
                                );
                            }}
                        </Formik>
                    </Route>
                    <Route>
                        <Formik
                            key={"login-form"}
                            initialValues={{
                                email: '',
                                password: ''
                            }}
                            validate={this.validateSignIn}
                            onSubmit={(values, actions) => {
                                actions.setStatus({submitting: true, loggedin: false, message: []});
                                this.props.store.account.login(values).then(
                                    status => {
                                        console.debug(status);
                                        actions.setSubmitting(false);
                                        actions.setStatus({submitting: false, loggedin: true, message: []});
                                        
                                        // If we are on #/login, go to #/
                                        const m = matchPath(navigation.toolbarRouter.location.pathname, "/login");
                                        if (m) {
                                            setTimeout(() => {
                                                    navigation.toolbarRouter.push("/");

                                                },
                                                1500);


                                        } else {
                                            setTimeout(() => {
                                                    // todo: implement returnUrl
       
                                                    const currentNodeUrl = navigation.pageContent.Url;
                                                    if(location.pathname === currentNodeUrl) {
                                                        location.href = "/";
                                                    }
                                                    else {
                                                        location.reload();
                                                    }
                                                },
                                                1500);
                                        }

                                    },
                                    error => {
                                        console.debug(error);
                                        //actions.setFieldError("custom", error.messages[0]);
                                        
                                        actions.setStatus({submitting: false, loggedin: false, messages:error.messages});
                                        actions.setSubmitting(false);

                                        
                                    }
                                );

                            }}

                        >
                            {({errors, touched, isSubmitting, isValid, status}) => {
                                return (
                                    <Form id="login-form">
                                        <h2>{dictionary["Login.Title"]}</h2>
                                        <div className={classnames("form-group", "input-group", {'has-warning': errors.email && touched.email})}>
                                            <Field className="form-control" name="email" type="email" autoComplete="username" placeholder={dictionary["Login.EmailPlaceholder"]} autoFocus/><span className="input-group-addon"><i
                                            className="material-icons mail"></i></span>
                                            {errors.email &&
                                                touched.email &&
                                                <div className="form-control-feedback">{errors.email}</div>}
                                        </div>
                                        <div className={classnames("form-group",
                                            "input-group",
                                            {'has-warning': errors.password && touched.password})}>
                                            <Field className="form-control" name="password" type="password" autoComplete="current-password" placeholder={dictionary["Login.PasswordPlaceholder"]}/><span className="input-group-addon"><i
                                            className="material-icons lock"></i></span>
                                            {errors.password &&
                                                touched.password &&
                                                <div className="form-control-feedback">{errors.password}</div>}
                                        </div>
                                        <button className="btn btn-success btn-block" type="submit" >
                                            {status && !status.submitting && status.loggedin ? <span>{dictionary["Login.Button.LoggedIn"]}&nbsp;<i key="icon" className="material-icons check"></i></span> : null}
                                            {status && status.submitting && !status.loggedin ? <span>{dictionary["Login.Button.Auth"]}</span> : null}
                                            {!status || (!status.sent && !status.loggedin) ? <span>{dictionary["Login.Button"]}</span> : null}
                                        </button>

                                        {/*{errors.custom && <div>{errors.custom}</div>}*/}
                                        {status && status.messages && status.messages.length > 0 && <div className="form-control-feedback">
                                            {status.messages.map((message, i) => {
                                                return <p key={i}>{message}</p>
                                            } )}    
                                        </div>}
                                        
                                        <br/>

                                        {(dictionary["Login.Instructions"] || "").split(";").map((x, i) => {
                                            //return (<p key={i}>{x}</p>);
                                            return (<p key={i} dangerouslySetInnerHTML={{__html: x}}></p>);
                                        })}

                                        <Link to={`${matchUrl}/resetpassword`}>{dictionary["Login.ForgotPasswordLink"]}</Link>
                                        <br/><br/>

                                        <button className={"btn btn-light btn-small"} onClick={(e) => {
                                            e.preventDefault();
                                            navigation.navigateToSiteUrl(null, navigation.marketSettings.MarketUrl)
                                        }}>{dictionary["Login.BackToSite"]}</button>

                                    </Form>
                                );
                            }}
                        </Formik>

                    </Route>
                </Switch>


            </div>);
    }
}

export default withRouter(SignIn)